import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';
import './Wallet.css';
import { Link } from "react-router-dom";
import { auth, firestore } from '../../firebase/firebaseConfig';
import { updateDoc, doc, onSnapshot, addDoc, collection, query, orderBy } from "@firebase/firestore";
import { onAuthStateChanged } from 'firebase/auth';

function Wallet ( props ) {
    let [ wallet, setWallet ] = useState( 0 );
    let [ transactions, setTransactions ] = useState( [] );
    let [ rateObject, setRateObject ] = useState( {
        rate: 1000,
        addRate: 1055,
        offer: "Recharge Rs. 1000 and get Rs. 1055 in LB Wallet"
    } );

    let rateArray = [
        {
            rate: 500,
            addRate: 511,
            offer: "Recharge Rs. 500 and get Rs. 511 in LB Wallet"
        },
        {
            rate: 1000,
            addRate: 1055,
            offer: "Recharge Rs. 1000 and get Rs. 1055 in LB Wallet"
        },
        {
            rate: 1500,
            addRate: 1611,
            offer: "Recharge Rs. 1500 and get Rs. 1611 in LB Wallet"
        },
        {
            rate: 2000,
            addRate: 2222,
            offer: "Recharge Rs. 2000 and get Rs. 2222 in LB Wallet"
        },
        {
            rate: 3000,
            addRate: 3355,
            offer: "Recharge Rs. 3000 and get Rs. 3355 in LB Wallet"
        },
        {
            rate: 4000,
            addRate: 4611,
            offer: "Recharge Rs. 4000 and get Rs. 4611 in LB Wallet"
        },
        {
            rate: 5000,
            addRate: 6011,
            offer: "Recharge Rs. 5000 and get Rs. 6011 in LB Wallet"
        }
    ];

    async function onload ( user ) {
        onSnapshot( doc( firestore, "users/" + user.uid + "/wallet", "wallet_id" ), ( snapshot ) => {
            setWallet( snapshot.data().wallet_balance.toFixed( 2 ) )
        } )

        onSnapshot( query( collection( firestore, "users/" + auth.currentUser.uid + "/transaction_history" ), orderBy( "timestamp", "desc" ) ), ( snapshot ) => {
            let transactionsRaw = [];
            snapshot.forEach( ( element ) => {
                transactionsRaw.push( {
                    message: element.data().message,
                    time: new Date( element.data().timestamp.seconds * 1000 ).toLocaleString(),
                    amount: element.data().amount,
                    method: element.data().method
                } )
            } )
            setTransactions( [ ...transactionsRaw ] );
        } )

        onSnapshot( doc( firestore, "users", auth.currentUser.uid ), ( snapshot ) => {
            let date = new Date().getDate();
            let claimed = snapshot.data().claim_offer_23 === "1" ? false : true;
            if ( date === 23 ) {
                if ( claimed === false ) {
                    document.querySelector( ".claim" ).style.display = "block";
                    document.querySelector( ".claimed" ).style.display = "none";
                    document.querySelector( ".claim-after" ).style.display = "none";
                } else {
                    document.querySelector( ".claim" ).style.display = "none";
                    document.querySelector( ".claimed" ).style.display = "block";
                    document.querySelector( ".claim-after" ).style.display = "none";
                }
            } else {
                document.querySelector( ".claim" ).style.display = "none";
                document.querySelector( ".claimed" ).style.display = "none";
                document.querySelector( ".claim-after" ).style.display = "block";
            }
        } );

        document.querySelector( ".loader-container" ).style.display = "none";
    }

    async function addMoney ( event, rateObjectRaw ) {
        event.preventDefault();
        var options = {
            "key": process.env.REACT_APP_RAZOR_KEY,
            "key_secret": process.env.REACT_APP_RAZOR_KEY_SECRET,
            "amount": ( parseInt( rateObjectRaw.rate ) * 100 ).toString(),
            "currency": "INR",
            "name": "Laundry Buddy",
            "description": "Adding Money to LB Wallet",
            "image": require( "../../images/logo.webp" ),
            "handler": async function ( response ) {
                await updateDoc( doc( firestore, "users/" + auth.currentUser.uid + "/wallet", "wallet_id" ), {
                    wallet_balance: parseInt( wallet ) + parseInt( rateObjectRaw.addRate )
                } )
                await addDoc( collection( firestore, "transaction_history_global" ), {
                    order_doc: "recharge",
                    amount: parseInt( rateObjectRaw.rate ),
                    order_total: 0,
                    customer_name: props.details.name,
                    via: "Wallet Recharge",
                    order_id: "recharge",
                    customer_id: auth.currentUser.uid,
                    time: new Date(),
                    source: "website"
                } )
                await addDoc( collection( firestore, "users/" + auth.currentUser.uid + "/transaction_history" ), {
                    order_id: null,
                    amount: "+Rs. " + parseInt( rateObjectRaw.rate ),
                    timestamp: new Date(),
                    message: "Money added to LB Wallet",
                    method: "Wallet Recharge",
                    source: "website"
                } )
            },
            "prefill": {
                "name": props.details.name, //your customer's name
                "email": props.details.email,
                "contact": props.details.phone
            },
            "theme": {
                "color": "#3399cc"
            }
        };
        var rzp1 = new window.Razorpay( options );
        rzp1.on( 'payment.failed', function ( response ) {
            console.log( response );
        } );
        rzp1.open();
    }

    async function addCashBack ( event ) {
        await updateDoc( doc( firestore, "users", auth.currentUser.uid ), {
            claim_offer_23: "0"
        } );
        await updateDoc( doc( firestore, "users/" + auth.currentUser.uid + "/wallet", "wallet_id" ), {
            wallet_balance: parseInt( wallet ) + parseInt( 23 )
        } )
        await addDoc( collection( firestore, "transaction_history_global" ), {
            order_doc: "23rd Offer Claim",
            amount: 23,
            order_total: 0,
            customer_name: props.details.name,
            via: "23rd Offer Claim",
            order_id: "23rd Offer Claim",
            customer_id: auth.currentUser.uid,
            time: new Date(),
            source: "website"
        } )
        await addDoc( collection( firestore, "users/" + auth.currentUser.uid + "/transaction_history" ), {
            order_id: null,
            amount: "+Rs. 23",
            timestamp: new Date(),
            message: "Free cashback worth",
            method: "Wallet Offer",
            source: "website"
        } )
    }

    useEffect( () => {
        document.title = "Laundry Buddy - Wallet | 20% Off Wallet Offers";
        document.querySelector( ".loader-container" ).style.display = "flex";
        onAuthStateChanged( auth, ( user ) => {
            if ( user ) {
                onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
                    if ( snapshot.exists() ) {
                        props.settingDetails( {
                            name: snapshot.data().name,
                            phone: snapshot.data().mobile.substring( 3 ),
                            email: snapshot.data().email,
                            address: snapshot.data().address,
                            pincode: snapshot.data().pincode
                        } )
                        onload( user );
                        document.querySelectorAll( ".add-wallet-price-button button" )[ 1 ].classList.add( "active" );
                        let width = document.querySelector( ".wallet-container swiper-container" ).clientWidth;
                        if ( width > 968 ) {
                            let height = width / 2.60;
                            document.querySelector( ".wallet-container swiper-container" ).style.height = ( height - 150 ) + "px";
                        } else if ( width < 968 ) {
                            let height = width / 1.60;
                            document.querySelector( ".wallet-container swiper-container" ).style.height = ( height ) + "px";
                        }
                    } else {
                        window.location.href = "/signup";
                    }
                } );
            } else {
                window.location.href = "/login";
            }
        } )
        setTimeout( () => {
            let width = document.querySelector( ".claim-inner-container" ).clientWidth;
            if ( width > 432 ) {
                let height = width / 2.78;
                document.querySelector( ".claim-inner-container" ).style.height = height + "px";
            } else if ( width < 432 ) {
                let height = ( width / 1.31 ) + 150;
                document.querySelector( ".claim-inner-container" ).style.height = height + "px";
            }
            document.querySelector( ".wallet-main-container" ).childNodes[ 3 ].shadowRoot.childNodes[ 4 ].style.backgroundColor = "transparent";
            document.querySelector( ".wallet-main-container" ).childNodes[ 3 ].shadowRoot.childNodes[ 4 ].style.marginBottom = "-0.3rem";
            document.querySelector( ".wallet-main-container" ).childNodes[ 3 ].shadowRoot.childNodes[ 4 ].childNodes[ 0 ].style.backgroundColor = "#66A9AFAD";
            document.querySelector( ".wallet-main-container" ).childNodes[ 3 ].shadowRoot.childNodes[ 4 ].childNodes[ 0 ].style.borderRadius = "5px";
        }, 500 )
    }, [] )

    return (
        <div className='wallet-main-container'>
            <div className='wallet-container'>
                <swiper-container autoplay loop={true} autoplay-delay={4000}>
                    <swiper-slide class="slide-2">
                        <div className='slide-header'>
                            <h1>Upto 20% Off using</h1>
                            <h1>Laundry Buddy Wallet</h1>
                        </div>
                        <Link to="/pricing" style={{ color: "white", textDecoration: "none" }}><Button>Schedule Free Pick Up</Button></Link>
                    </swiper-slide>
                    <swiper-slide class="slide-1">
                        <div className='slide-header'>
                            <h1>CLAIM RS.23 FOR FREE</h1>
                            <h2>ON 23RD OF EVERY</h2>
                            <h2>MONTH</h2>
                        </div>
                        <Link to="/pricing" style={{ color: "white", textDecoration: "none" }}><Button>Schedule Free Pick Up</Button></Link>
                    </swiper-slide>
                    <swiper-slide class="slide-4">
                        <div className='slide-header partner'>
                            <h1>Partner With Laundry</h1>
                            <h1>Buddy to expand your</h1>
                            <h1>Business</h1>
                        </div>
                        <Link to="/franchise" style={{ color: "white", textDecoration: "none" }}><Button>Get In Touch</Button></Link>
                    </swiper-slide>
                </swiper-container>
                <div className='add-wallet-container'>
                    <div className='add-wallet-form-container'>
                        <div>
                            <svg width="75" height="36" viewBox="0 0 75 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M66.8516 14.6667V7.33333H8.1849V58.6667H66.8516V51.3333H37.5183C35.4932 51.3333 33.8516 49.6918 33.8516 47.6667V18.3333C33.8516 16.3083 35.4932 14.6667 37.5183 14.6667H66.8516ZM4.51823 0H70.5183C72.5434 0 74.185 1.64164 74.185 3.66667V62.3333C74.185 64.3584 72.5434 66 70.5183 66H4.51823C2.4932 66 0.851562 64.3584 0.851562 62.3333V3.66667C0.851562 1.64164 2.4932 0 4.51823 0ZM41.185 22V44H66.8516V22H41.185ZM48.5183 29.3333H59.5183V36.6667H48.5183V29.3333Z" fill="#97C5C9" />
                            </svg>
                            <div>
                                <span>Rs. {wallet}</span>
                                <span>Your Wallet Balance</span>
                            </div>
                        </div>
                        <div>
                            <span>Amount to be added in wallet</span>
                            <span>Rs. <input type="text" value={rateObject.rate} readOnly /></span>
                        </div>
                        <div>
                            <span>{rateObject.offer}</span>
                        </div>
                        <div>
                            <Button onClick={event => addMoney( event, rateObject )}>Add Money</Button>
                        </div>
                    </div>
                    <div className='add-wallet-price-button'>
                        {rateArray.map( ( element ) => (
                            <Button onClick={event => {
                                document.querySelectorAll( ".add-wallet-price-button button" ).forEach( ( element ) => {
                                    element.classList.remove( "active" );
                                } )
                                event.target.classList.add( "active" );
                                let object = {
                                    rate: element.rate,
                                    addRate: element.addRate,
                                    offer: element.offer
                                };
                                setRateObject( { ...object } );
                            }}>{element.rate}</Button>
                        ) )}
                    </div>
                    <div>
                        <Button onClick={event => addMoney( event, rateObject )}>Add Money</Button>
                    </div>
                </div>
            </div>
            <h2>Wallet offers</h2>
            <div className='wallet-offers-container'>
                {rateArray.map( ( element, index ) => (
                    <div className='services-content-card'>
                        <div className='card-image'>
                            <img src={require( "../../images/wallet-offer-image.png" )} className="card-image-normal" alt="" />
                            <img src={require( "../../images/wallet-offer-image-dark.png" )} className="card-image-dark" alt="" />
                        </div>
                        <div className='card-head'>
                            <h6>Rs. {element.rate}</h6>
                        </div>
                        <div className='card-content'>
                            {element.offer}
                        </div>
                        <div className='card-button'>
                            <Button onMouseEnter={event => {
                                document.querySelectorAll( ".card-image-normal" )[ index ].style.display = "none";
                                document.querySelectorAll( ".card-image-dark" )[ index ].style.display = "block";
                            }} onMouseLeave={event => {
                                document.querySelectorAll( ".card-image-dark" )[ index ].style.display = "none";
                                document.querySelectorAll( ".card-image-normal" )[ index ].style.display = "block";
                            }} onClick={event => {
                                setRateObject( {
                                    rate: element.rate,
                                    addRate: element.addRate,
                                    offer: element.offer
                                } );
                                let object = {
                                    rate: element.rate,
                                    addRate: element.addRate,
                                    offer: element.offer
                                };
                                addMoney( event, object );
                            }}>Add Money</Button>
                        </div>
                    </div>
                ) )}
            </div>
            <swiper-container autoplay loop={true} autoplay-delay={6000} space-between={10} slides-per-view={( document.querySelector( ".wallet-main-container swiper-container" ) ? document.querySelector( ".wallet-main-container swiper-container" ).clientWidth : "" ) < 350 ? 1 : 2} scrollbar={true} className='services-content-container wallet'>
                {rateArray.map( ( element, index ) => (
                    <swiper-slide className='services-content-card'>
                        <div className='card-image'>
                            <img src={require( "../../images/wallet-offer-image.png" )} className="card-image-normal" alt="" />
                            <img src={require( "../../images/wallet-offer-image-dark.png" )} className="card-image-dark" alt="" />
                        </div>
                        <div className='card-head'>
                            <h6>Rs. {element.rate}</h6>
                        </div>
                        <div className='card-content'>
                            {element.offer}
                        </div>
                        <div className='card-button'>
                            <Button onMouseEnter={event => {
                                document.querySelectorAll( ".card-image-normal" )[ index ].style.display = "none";
                                document.querySelectorAll( ".card-image-dark" )[ index ].style.display = "block";
                            }} onMouseLeave={event => {
                                document.querySelectorAll( ".card-image-dark" )[ index ].style.display = "none";
                                document.querySelectorAll( ".card-image-normal" )[ index ].style.display = "block";
                            }} onClick={event => {
                                setRateObject( {
                                    rate: element.rate,
                                    addRate: element.addRate,
                                    offer: element.offer
                                } );
                                let object = {
                                    rate: element.rate,
                                    addRate: element.addRate,
                                    offer: element.offer
                                };
                                addMoney( event, object );
                            }}>Add Money</Button>
                        </div>
                    </swiper-slide>
                ) )}
            </swiper-container>
            <div className='transactions-container'>
                <h4 style={{ fontWeight: "700", color: "grey" }}>Transactions</h4>
                <h1 style={{ fontWeight: "700" }}>Check Out Your LB Wallet History</h1>
                <div className='transactions'>
                    {transactions.map( ( element ) => (
                        <div className='transaction-container'>
                            <div>
                                <svg width="75" height="46" viewBox="0 0 75 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M66.8516 14.6667V7.33333H8.1849V58.6667H66.8516V51.3333H37.5183C35.4932 51.3333 33.8516 49.6918 33.8516 47.6667V18.3333C33.8516 16.3083 35.4932 14.6667 37.5183 14.6667H66.8516ZM4.51823 0H70.5183C72.5434 0 74.185 1.64164 74.185 3.66667V62.3333C74.185 64.3584 72.5434 66 70.5183 66H4.51823C2.4932 66 0.851562 64.3584 0.851562 62.3333V3.66667C0.851562 1.64164 2.4932 0 4.51823 0ZM41.185 22V44H66.8516V22H41.185ZM48.5183 29.3333H59.5183V36.6667H48.5183V29.3333Z" fill="#97C5C9" />
                                </svg>
                                <div>
                                    <span>{element.message}</span>
                                    <span>{element.time}</span>
                                </div>
                            </div>
                            <div>
                                <span>{element.amount}</span>
                                <span>{element.method}</span>
                            </div>
                        </div>
                    ) )}
                </div>
            </div>
            <div className='claim-container'>
                <h1 style={{ fontWeight: "700" }}>Earn a Reward</h1>
                <h6>you can claim Rs.23 for free on 23rd of every month so don't forget to login.</h6>
                <div className='claim-inner-container'>
                    <div className='claim-header'>
                        <h2>CLAIM RS.23 FOR FREE</h2>
                        <h2>ON 23RD OF EVERY MONTH</h2>
                        <span className='claim-after' style={{ display: "none" }}>CheckIn with us on 23rd for free credit points</span>
                        <Button className='claim' onClick={event => addCashBack( event )} style={{ display: "none" }}>Claim Now</Button>
                        <Button className='claimed' style={{ display: "none" }}>Already Claimed</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Wallet